import React, { useContext, useEffect, useRef } from "react";
import { langContext, LangToggle, termsUrl } from "../api/Lang";
import { initSentry } from "../api/sentry";
import LoginForm from "./LoginForm";
import { useLoginStrings } from "./login-strings";
import "./login.css";

export default function Login() {
    const [lang] = useContext(langContext);
    const s = useLoginStrings();
    const prevLangRef = useRef(lang);
    const isAdminPath = window.location.pathname.startsWith('/admin');

    // Ensure Sentry is initialized (like OrderApp does)
    // Check for existing cookie consent and initialize Sentry if consent exists
    useEffect(() => {
        const hasConsent = localStorage.getItem('cookiesConsent');
        const consentAccepted = hasConsent === 'accepted';
        if (consentAccepted) {
            initSentry();
        }
    }, []);

    // Reload page when language changes on the login screen (not on unmount after sign-in)
    useEffect(() => {
        if (prevLangRef.current !== lang) {
            window.location.reload();
        }
        prevLangRef.current = lang;
    }, [lang]);

    return (
        <div className="login-page">
            <div className="header login-page-header">
                <div className='header-profile'>
                    <LangToggle edgeStyles={{ first: { marginLeft: '20px' }, last: { marginRight: '40px' } }} />
                </div>
            </div>
            <div className='login-logo'>
                <img src="/img-assets/logo-compact-light.svg" alt="" />
            </div>
            <div className="login-content-column">
                {!isAdminPath && (
                    <div className="login-how-it-works-wrap">
                        <a
                            className="login-how-it-works"
                            href={termsUrl('instructions', lang)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="login-how-it-works-body">
                                <div className="login-how-it-works-title">
                                    {s.howItWorksTitle}
                                </div>
                                <div className="login-how-it-works-subtitle">
                                    {s.howItWorksSubtitle}
                                </div>
                            </div>
                            <div className="login-how-it-works-chevron">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="rgb(154, 165, 177)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </a>
                    </div>
                )}
            </div>
            <LoginForm />
        </div>
    );
}
